var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilm = function SvgFilm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M43 42H5a4 4 0 0 1-4-4V10a4 4 0 0 1 4-4h38a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4M12 8H5a2 2 0 0 0-2 2v2h9zm11 0h-9v4h9zm11 0h-9v4h9zm11 2a2 2 0 0 0-2-2h-7v4h9zm0 4H3v20h42zm0 22h-9v4h-2v-4h-9v4h-2v-4h-9v4h-2v-4H3v2a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2zm-23.379-6.235A1 1 0 0 1 21 30a1 1 0 0 1-1-1V19a1 1 0 0 1 1-1c.213 0 .4.082.563.196l7.771 4.872A.99.99 0 0 1 30 24a.98.98 0 0 1-.405.783z",
    clipRule: "evenodd"
  })));
};
export default SvgFilm;